"use client";

import { Button } from "@/components/shared/ui/button";
import { setCustomerFavoriteAction } from "@/lib/customers/customer-actions";
import { useToast } from "@/state-management/hooks/use-toast";
import { Heart } from "lucide-react";
import { useState } from "react";

export default function CustomerFavoriteButton({
    customerID,
    initialIsFavorite
}: {
    customerID: number;
    initialIsFavorite: boolean;
}) {
    const { toast } = useToast();
    const [isFavorite, setIsFavorite] = useState<boolean>(initialIsFavorite);
    const handleFavoriteClick = async (customerId: number, newFavorite: boolean) => {
        try {
            setIsFavorite(newFavorite);
            const result = await setCustomerFavoriteAction(customerId, newFavorite);

            if (!result.success) {
                setIsFavorite(!newFavorite);
                toast({
                    variant: "destructive",
                    title: "Error",
                    description: "Failed to update favorite status"
                });
            } else {
                toast({
                    variant: "default",
                    title: "Success",
                    description: "Favorite customers updated"
                });
            }
        } catch (error) {
            setIsFavorite(!newFavorite);
            toast({
                variant: "destructive",
                title: "Error",
                description: "Failed to update favorite status"
            });
        }
    };
    return (
        <Button
            variant="ghost"
            onClick={() => handleFavoriteClick(customerID, !isFavorite)}
            aria-label={isFavorite ? "Remove from favorites" : "Add to favorites"}
            title="Set or remove this customer as a favorite"
        >
            <Heart
                className={`!h-10 !w-10 ${
                    isFavorite ? "fill-red-500 text-red-500" : "text-gray-400"
                }`}
            />
        </Button>
    );
}
